import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Header = styled.div`
    display: flex;
    align-items: center;
    background: #f5f5f5 0% 0% no-repeat padding-box;
    // margin-left: 25px;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '10px')};
    padding: 6px 0;
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '5px')};
    width: ${({ width }) => (width ? width : '100%')};
    height: ${({ height }) => (height ? height : '22px')};
    text-align: left;
    letter-spacing: 0px;
    text-transform: uppercase;
    opacity: 1;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '15px'};
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #4f4f4f;

    ${media.mobileDevice`
        margin-bottom:15px ;
        height: ${({ mbHeight }) => mbHeight};
        padding-right:0px !important;
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
        margin-left:${({ mbmarginLeft }) =>
            mbmarginLeft ? mbmarginLeft : '-19.5px'};
        margin-right:${({ mbmarginLeft }) =>
            mbmarginLeft ? mbmarginLeft : '-19.5px'};
        padding-left: ${({ mbPaddingLeft }) =>
            mbPaddingLeft ? mbPaddingLeft : '5px'};
        display: ${({ mbDisplay }) => (mbDisplay ? mbDisplay : 'flex')};
    `};
`;

export const DetailsMainContainerBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'space-between'};

    ${media.mobileDevice`
        width: 90%;
        margin: 0px;
        flex-direction: column;
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : ' ')};
    `}
`;

export const ImageBox = styled.div`
    display: flex;
    align-items: center;
    width: 30px;
    height: 30px;
    justify-content: center;
    border: ${({ border }) => (border ? border : '')};
    border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '')};
    background-color: ${({ backgroundColor }) =>
        backgroundColor ? backgroundColor : ''};
    box-shadow: ${({ boxShadow }) => (boxShadow ? boxShadow : '')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
`;

export const ImageWrapper = styled.div`
    cursor: pointer;
    width: 30px;
    height: 30px;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ padding }) => (padding ? padding : '')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '')};
`;

export const MainTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    text-align: left;
    color: #140f4b;
    letter-spacing: -0.12px;
    opacity: 1;
    // margin-left: 18px;
    // margin-top: 19px;
    display: flex;
    justify-content: space-between;
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
    font-size: 15px;
    `}
`;
export const MainContainerItems = styled.div`
    // width: 47%;
    display: flex;
    flex-direction: column;
    // flex-wrap: wrap;
    padding: ${({ dkPadding }) => (dkPadding ? dkPadding : '0 20px')};
    flex-basis: 50%;
    box-sizing: border-box;
    // margin-left: 25px;
    margin-top: ${({ setMarginTop }) => setMarginTop};
    margin-bottom: ${({ setMarginBottom }) =>
        setMarginBottom ? '0px' : '0px'};
    max-width: ${({ setMaxWidth }) => (setMaxWidth ? setMaxWidth : '58%')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '')};
    //setMarginBottom ? '0px' : '0px'};

    ${media.mobileDevice`
        width: 100%;
        margin-bottom: ${({ mbMarginBottom }) => mbMarginBottom};
        padding: 0;
        max-width: 100%
        margin-left: ${({ mbMarginLeft }) => (mbMarginLeft ? mbMarginLeft : '')};
    `}
    @media only screen and (min-width: 375px) and (max-width: 415px) {
        margin-top: ${({ mbMarginTop }) =>
            mbMarginTop === true
                ? '-150px'
                : mbMarginTop === 'PO'
                ? '-120px'
                : ''};
    }
    @media only screen and (min-width: 430px) and (max-width: 450px) {
        margin-top: ${({ mbMarginTop }) =>
            mbMarginTop === true
                ? '-124px'
                : mbMarginTop == 'PO'
                ? '-90px'
                : ''};
    }
`;

export const Title = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
margin-bottom: ${({setMarginBottom }) =>
    setMarginBottom ? '':'8px'};
    display: ${({ display }) => (display ? display : '')};
    align-items: baseline;
    &:after {
        content: '${(props) => (props.showAstrisk ? '*' : '')}';
        color: red;
        padding-left: 3px;
    }
    ${media.mobileDevice`
    margin-bottom:${({ marginBottom }) =>
        marginBottom ? marginBottom : '8px'};
    margin-left: ${({marginLeft }) =>
    marginLeft ? '0px':''};
    
`}
`;

export const Subtitle = styled.div`
    font-family: 'AvenirNextWorld Regular';
    color: #202124;
    font-size: 15px;
    display: flex;
    margin-bottom:${({ marginBottom}) => (marginBottom ? marginBottom : '')};
    // padding: 0 20px;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    text-transform: ${({ textTransform }) =>
        textTransform ? textTransform : ''};
    // address should come in 4 lines
    ${media.mobileDevice`
    width:${({ width }) => (width ? width : '')};
    margin-left: ${({marginLeft }) =>
    marginLeft ? '0px':''};
`}
`;

export const SpecialHandlerMessage = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0')};
    width: 70%;
    font-family: 'AvenirNextWorld Regular';
    font-size: 11px;
    line-height: 16px;
    letter-spacing: 0px;
    color: #ed002a;
    opacity: 1;
    ${media.mobileDevice`
        width: 100%;
    `}
`;
